import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/admin");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 rf-grain px-4">
      <div className="w-full max-w-md rf-fade-up">
        <Link to="/" className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="Roof Fix Houston" className="h-28 w-28 object-contain" />
        </Link>
        <div className="bg-white border border-zinc-200 p-8 shadow-xl">
          <p className="text-xs tracking-[0.25em] uppercase text-zinc-400 font-bold mb-1">Contractor Portal</p>
          <h1 className="font-chivo text-3xl font-black tracking-tight mb-6 text-zinc-900">Admin Sign In</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs tracking-wider uppercase text-zinc-500 font-bold">Email</label>
              <Input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 bg-white border-zinc-300 rounded-none focus-visible:ring-red-500 h-11 text-zinc-900"
                placeholder="admin@rooffixhouston.com"
              />
            </div>
            <div>
              <label className="text-xs tracking-wider uppercase text-zinc-500 font-bold">Password</label>
              <Input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 bg-white border-zinc-300 rounded-none focus-visible:ring-red-500 h-11 text-zinc-900"
                placeholder="••••••••"
              />
            </div>
            <Button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-none bg-[#EF233C] hover:bg-[#D90429] text-white font-bold tracking-wide transition-all duration-200"
            >
              <Lock weight="bold" className="mr-2" size={18} />
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
        <Link to="/" className="block text-center mt-6 text-sm text-zinc-500 hover:text-[#EF233C] transition-colors">
          ← Back to estimator
        </Link>
      </div>
    </div>
  );
}
